import { render, staticRenderFns } from "./RFQEdit.vue?vue&type=template&id=0cc08204&scoped=true&"
import script from "./RFQEdit.vue?vue&type=script&lang=js&"
export * from "./RFQEdit.vue?vue&type=script&lang=js&"
import style0 from "./RFQEdit.vue?vue&type=style&index=0&id=0cc08204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc08204",
  null
  
)

export default component.exports